import { render, staticRenderFns } from "./Widget1.vue?vue&type=template&id=4af0bc4d"
import script from "./Widget1.vue?vue&type=script&lang=js"
export * from "./Widget1.vue?vue&type=script&lang=js"
import style0 from "./Widget1.vue?vue&type=style&index=0&id=4af0bc4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports